import en from './signupStrings.en';

export default {
  en,
};
